<template>
  <div v-if="loaded">
    <!-- <v-container v-if="!enrolledStudent.locked_grades">
            <v-row>
                <v-col>
                    <v-alert type="error">Morate unijeti sve zaključne ocjene kako biste mogli izraditi dokument.</v-alert>
                </v-col>
            </v-row>
        </v-container> -->
    <v-container>
      <v-row justify="center">
        <v-col
            v-if="$checkPermission('department enrollment create document')"
            cols="12"
            sm="4"
        >
          <v-btn
              depressed
              color="primary"
              block
              height="44"
              class="text-none"
              @click="openDialog"
          >
            Izradite dokument
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12">
          <v-alert v-if="diplomasCount === 0" type="info" color="blue darken-1">
            Učenik nema dodanih dokumenata.
          </v-alert>
          <div v-else>
            <v-list-item
                v-for="diploma in combinedDiplomas"
                :key="diploma.id"
                class="px-4 px-sm-8 py-3 mb-4 flex-column flex-sm-row"
                :class="{ 'optional-subject-list': $vuetify.breakpoint.xs }"
                style="border: thin solid rgba(0, 0, 0, 0.12)"
            >
              <v-list-item-content three-line>
                <v-list-item-title
                    style="white-space: normal"
                    class="mb-3 font-weight-medium title"
                >
                  {{ `${diploma.type == 2 ? 'Učenička knjižica' : 'Svjedodžba'} za ${diploma.semester}. polugodište` }}
                  <v-chip v-if="diploma.official" class="ml-2 success--text">
                    SLUŽBENA
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle
                    v-for="(val, key, index) in diploma.type == 2 ? {} : optimizeData(diploma)"
                    :key="index"
                    class="mb-1"
                    style="white-space: normal; font-size: 16px"
                >
                  <span class="font-weight-light"> {{ key }}: </span>
                  {{ val ? val : "-" }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="align-self-auto">
                <v-col
                    v-if="
                    !diploma.official &&
                      $checkPermission('department enrollment delete document')
                  "
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="error"
                      outlined
                      block
                      @click="openDelete(diploma.id)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-delete</v-icon>
                    Izbriši
                  </v-btn>
                </v-col>
                <v-col
                    v-if="
                    !diploma.official &&
                      $checkPermission('department enrollment edit document') && diploma.type != 2
                  "
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="primary"
                      block
                      @click="openEdit(diploma)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-pencil</v-icon>
                    Uredi
                  </v-btn>
                </v-col>
                <v-col class="pa-0">
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="primary"
                      block
                      target="_blank"
                      @click="goToDiploma(diploma)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-file-find</v-icon>
                    Pregled
                  </v-btn>
                </v-col>
                <v-col
                    v-if="diploma.official && $checkPermission('demand create')"
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none mb-3"
                      color="primary"
                      text
                      block
                      @click="openDemandDialog(diploma.id)"
                  >
                    Pošalji zahtjev za brisanjem dokumenta
                  </v-btn>
                </v-col>
                <v-col
                    v-if="
                    !diploma.official &&
                      $checkPermission('department enrollment lock document')
                  "
                    class="pa-0"
                >
                  <v-btn
                      depressed
                      class="text-none"
                      color="error"
                      block
                      @click="openLock(diploma.id)"
                  >
                    <v-icon class="mr-2" size="20"> mdi-lock</v-icon>
                    Potvrdi
                  </v-btn>
                </v-col>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        v-model="dialog"
        @click:outside="closeDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn @click.native="closeDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items>
            <v-btn
                @click="preFillData"
                color="primary"
                depressed
                large
                v-if="currentRole.role_id === 1"
            >
              Automatska popuna
            </v-btn>
            <v-btn @click.native="saveItem" color="primary" depressed large
            >Spremi
            </v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-container>
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in filteredItems"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>
                    <!--Label for the form-->
                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-2"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                            color:
                              errors.length > 0
                                ? 'rgb(236 29 36) !important'
                                : '',
                            opacity: 0.8,
                            marginTop: '5px',
                            marginRight: '15px',
                          }"
                        >
                          {{ item.title }}:
                        </p>
                      </div>
                    </v-col>

                    <!-- Text field -->
                    <v-col xs="12" md="9">
                      <v-text-field
                          :ref="item.name"
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]"
                      >
                      </v-text-field>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea' &&
                            item.name !== 'remark' &&
                            item.name !== 'final_success_description'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="item.placeholder"
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea' &&
                            item.name === 'remark' &&
                            item.name !== 'final_success_description'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <v-textarea
                          :name="item.name"
                          outlined
                          rows="3"
                          :placeholder="item.placeholder"
                          :prepend-icon="item.icon"
                          v-if="
                          item.tag === 'textarea' &&
                            item.name === 'final_success_description' &&
                            item.name !== 'remark'
                        "
                          v-model="form[item.name]"
                      >
                      </v-textarea>

                      <!-- Select field -->

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno...' : ''"
                          :items="item.source"
                          :disabled="item.disabled"
                          :name="item.name"
                          :item-text="item.text"
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'select' && item.name !== 'semester'"
                          v-model="form[item.name]"
                      >
                      </v-autocomplete>

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno...' : ''"
                          :items="item.source"
                          :disabled="item.disabled"
                          :name="item.name"
                          :item-text="item.text"
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'select' && item.name === 'semester'"
                          v-model="form[item.name]"
                          @change="changeFormItems"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text style="padding-top: 20px">
          {{ deleteText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" depressed large outlined
          >Odustani
          </v-btn
          >
          <v-btn @click="deleteStudentDocument(combinedDiplomas.filter(d=>d.id==editIndex)[0])" color="error" depressed large
          >Izbriši
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="lockDialog"
        width="500"
        @click:outside="lockDialog = false"
    >
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text class="pt-5">
          Jeste li sigurni da želite potvrditi? <br/>
          <span class="font-weight-bold">Upozorenje:</span>
          Kada potvrdite dokument više nećete imati mogućnost uređivanja.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="lockDialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="error"
              @click="createOfficialDocument(combinedDiplomas.filter(d=>d.id==editIndex)[0])"
              class="text-none"
              depressed
              large
          >Potvrdi
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="demandDialog"
        width="400"
        @click:outside="closeDemandDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Pošalji zahtjev</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeDemandDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="mt-6">
          <v-row>
            <v-col cols="12">
              <v-textarea
                  outlined
                  dense
                  auto-grow
                  v-model="demandReason"
                  rows="3"
                  label="Razlog"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="closeDemandDialog"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="primary"
              class="text-none"
              @click="sendDemand(combinedDiplomas.filter(d=>d.id==editIndex)[0])"
              depressed
              large
          >Potvrdi
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="loadingDialog"
        height="400"
        width="500"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-title>Stvaranje nove diplome</v-card-title>
        <v-card-text>
          <br>
          {{ bufferText }}
          <v-progress-linear
              v-model="value"
              :buffer-value="bufferValue"
              color="white"
              style="margin-top:30px; margin-bottom: 30px;"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {extend, setInteractionMode, ValidationProvider} from "vee-validate";
import {digits, email, max, min, required} from "vee-validate/dist/rules";
import ApiV2 from "@/services/ApiV2";
import {serverBus} from "@/main";

export default {
  components: {
    ValidationProvider,
  },

  props:{
    department:{
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      form: {
        semester: 1,
      },
      studentInfo: {},
      loaded: false,
      diplomas: [],
      booklets: [],
      diplomasCount: 0,
      editIndex: -1,
      deleteDialog: false,
      loadingDialog: false,
      lockDialog: false,
      demandDialog: false,
      demandReason: "",
      deleteText:
          "Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?",
      items: [
        {
          data: "semester",
          name: "semester",
          text: "type",
          options: "",
          rules: "required",
          disabled: false,
          source: [
            {value: 1, type: "1. polugodište"},
            {value: 2, type: "2. polugodište"},
          ],
          tag: "select",
          title: "Polugodište",
        },
        {
          data: "conduct",
          name: "conduct",
          text: "type",
          rules: "required",
          source: [
            {value: 5, type: "Uzorno"},
            {value: 4, type: "Vrlo dobro"},
            {value: 3, type: "Dobro"},
            {value: 2, type: "Zadovoljavajuće"},
            {value: 1, type: "Loše"},
            {value: 6, type: "Neocijenjeno"},
          ],
          tag: "select",
          title: "Vladanje",
        },
        {
          data: "justified_hours",
          name: "justified_hours",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "number",
          title: "Opravdani",
        },
        {
          data: "unjustified_hours",
          name: "unjustified_hours",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "number",
          title: "Neopravdani",
        },
        {
          data: "parish_register",
          name: "parish_register",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "string",
          title: "Matična knjiga",
        },
        {
          data: "parish_register_number",
          name: "parish_register_number",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "string",
          title: "Matični broj učenika",
        },
        {
          data: "docket_number",
          name: "docket_number",
          options: "",
          rules: "required",
          source: [],
          tag: "input",
          type: "text",
          title: "Urudžbeni broj",
        },
        // {
        //     data: "commendation",
        //     name: 'commendation',
        //     options: '',
        //     rules: '',
        //     source: [],
        //     tag: 'textarea',
        //     title: 'Pohvala'
        // },
        // {
        //     data: "pedagogical_measure",
        //     name: 'pedagogical_measure',
        //     options: '',
        //     rules: '',
        //     source: [],
        //     tag: 'textarea',
        //     title: 'Pedagoška mjera'
        // },
        {
          data: "remark",
          name: "remark",
          options: "",
          rules: "",
          source: [],
          placeholder: "(pohvale i uspjesi, pedagoške mjere i sl.)",
          tag: "textarea",
          title: "Napomena",
        },
        {
          data: "final_success_description",
          name: "final_success_description",
          options: "",
          rules: "",
          source: [],
          placeholder: "Unosi se za učenike s opisnim ocjenama",
          tag: "textarea",
          title: "Opis općeg postignuća",
        },
        {
          data: "conduct_description",
          name: "conduct_description",
          options: "",
          rules: "",
          source: [],
          tag: "textarea",
          title: "Obrazloženje ocjene vladanja",
        },
      ],
    };
  },

  created() {
    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", {...required, message: "Ovo polje je obavezno."});

    this.getStudentDiplomas();
  },

  async mounted() {
    await this.getStudentInfo();
  },

  computed: {
    filteredItems() {
      return this.items.map(item => {
        if (item.data === "conduct") {
          if (this.currentSchool?.canton?.id === 5) {
            item.source = [
              { value: 5, type: "Uzorno" },
              { value: 4, type: "Vrlo dobro" },
              { value: 3, type: "Dobro" },
              { value: 2, type: "Zadovoljavajuće" },
              { value: 1, type: "Loše" },
              { value: 6, type: "Neocijenjeno" }
            ];
          } else {
            item.source = [
              { value: 5, type: "Uzorno" },
              { value: 3, type: "Dobro" },
              { value: 1, type: "Loše" },
              { value: 6, type: "Neocijenjeno" }
            ];
          }
        }
        return item;
      });
    },

    combinedDiplomas(){
      return this.diplomas.concat(this.booklets);
    },

    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },

    dialogTitle() {
      return this.editIndex > -1 ? "Uredite dokument" : "Dodajte dokument";
    },

    currentSchool() {
      return this.$store.getters.getSchool;
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
  },

  methods: {
    async goToDiploma(diploma) {
      if (diploma.type == 2){
        let baseUrl = process.env.VUE_APP_SKOLE_API_URL;

        baseUrl = baseUrl + "v2/";

        window.open(`${baseUrl}files/${diploma.student_booklet_file?.uuid}`, "_blank");

      }else{

        window.open(
            `/uvjerenje/${diploma.uuid}?name=${diploma.diploma_file.name}`,
            "_blank"
        );
      }

    },

    async getStudentDocketNumber() {
      let {data} = await ApiV2.get(`diplomas/calculate_docket_number/${this.enrolledStudent?.id}`, {params: {semester: this.form.semester}})
      this.form.docket_number = data
      if (this.dialog) {
        this.dialog = false
        this.dialog = true
      }
    },

    async openDialog() {


      this.editIndex = -1;
      this.form.semester = 1;
      await this.getStudentDocketNumber()

      if (this.studentInfo?.user?.student_schools.length > 0) {
        let parishInfo = this.studentInfo?.user?.student_schools?.filter(x => x.school_id === parseInt(localStorage.getItem('school_id')))[0]
        this.form.parish_register = parishInfo?.parish_register
        this.form.parish_register_number = parishInfo?.parish_register_number
      }
      this.form.conduct = this.studentInfo?.conduct_first
      this.form.justified_hours = this.studentInfo?.absences.filter(x => x.justified === 2).length
      this.form.unjustified_hours = this.studentInfo?.absences.filter(x => x.justified === 1).length

      this.dialog = true;
    },

    changeFormItems() {
      this.getStudentDocketNumber()

      if (this.form.semester === 1) {
        this.form.conduct = this.studentInfo?.conduct_first
        // this.form.justified_hours = this.studentInfo?.absences.filter(x=>x.justified===2).length
        // this.form.unjustified_hours = this.studentInfo?.absences.filter(x=>x.justified===1).length
      } else {
        this.form.conduct = this.studentInfo?.conduct_second
        // this.form.justified_hours = this.studentInfo?.absences.filter(x=>x.justified===2).length
        // this.form.unjustified_hours = this.studentInfo?.absences.filter(x=>x.justified===1).length
      }
      if (this.dialog) {
        this.dialog = false
        this.dialog = true
      }
    },

    openLock(diplomaId) {
      this.lockDialog = true;
      this.editIndex = diplomaId;
    },

    openEdit(diploma) {
      this.dialog = true;
      this.form = diploma;
      this.editIndex = diploma.id;
    },

    openDelete(diplomaId) {
      this.editIndex = diplomaId;
      this.deleteDialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.form = {};

      for (let i = 0; i < this.$refs.provider.length; i++) {
        this.$refs.provider[i].reset();
      }
    },

    openDemandDialog(diplomaId) {
      this.demandDialog = true;
      this.demandReason = "";
      this.editIndex = diplomaId;
    },

    closeDemandDialog() {
      this.demandDialog = false;
    },

    optimizeData(item) {
      let conduct = 0;

      switch (item.conduct) {
        case 1:
          conduct = "Loše";
          break;
        case 2:
          conduct = "Zadovoljavajuće";
          break;
        case 3:
          conduct = "Dobro";
          break;
        case 4:
          conduct = "Vrlo dobro";
          break;
        case 5:
          conduct = "Uzorno";
          break;
        case 6:
          conduct = "Neocijenjeno";
          break;
        default:
          console.log("Nema vladanja");
          break;
      }

      return {
        "Prosječna ocjena": item.average_grade,
        "Zaključna ocjena": item.final_success,
        Vladanje: conduct,
        "Opravdani sati": item.justified_hours,
        "Neopravdani sati": item.unjustified_hours,
      };
    },

    getStudentDiplomas() {
      ApiV2.get(`department_enrollment/${this.enrolledStudent.id}/diplomas`, {
        params: {
          perPage: -1,
          with: "diplomaFile",
        },
      })
          .then(async (response) => {
            this.diplomas = response.data.data;
            this.diplomas.map(d => d.type = 1)
            this.diplomasCount = response.data.total;
            if (this.currentSchool?.canton?.id == 5 && !this.department?.are_numerical_grades) {
              let {data} = await ApiV2.get(`department_enrollment/${this.enrolledStudent.id}/studentBooklets`, {params:{perPage: -1, with:['studentBookletFile']}});
              this.booklets = data.data;
              this.booklets.map(b => b.type = 2)
            }

          })
          .finally(() => {
            this.loaded = true;
          });
    },
    async getStudentInfo() {
      let {data} = await ApiV2.get(`departments/${this.enrolledStudent?.department_id}/departmentEnrollments`, {
            params: {
              with: ['user.studentSchools', 'absences'],
              filter: {
                user_id: this.enrolledStudent?.user_id
              }
            },
          }
      )
      this.studentInfo = data.data[0];

    },
    async startBuffer() {
      this.loadingDialog = true;
      this.bufferText = 'Kreiranje dokumenta...'

      clearInterval(this.interval)

      const self = this;
      this.value = 10
      this.bufferValue = 20

      setTimeout(() => {
        self.value = 20
        this.bufferValue = 40
      }, 700)

      setTimeout(() => {
        self.value = 40
        this.bufferValue = 100
        this.bufferText = 'Generiranje pdf-a..'
      }, 1000)

      setTimeout(() => {
        self.value = 80
        this.bufferText = 'Učitavanje dokumenta..'
      }, 2000)

      setTimeout(() => {
        self.value = 100
        this.bufferText = 'Još samo trenutak..'
      }, 3000)

      setTimeout(() => {
        self.value = 101
        self.loadingDialog=false
        self.loaded=true
      }, 4000)
      /*
      this.interval = setInterval(() => {
        this.value += Math.random() * (55 - 5) + 5
        this.bufferValue = 100

        if (this.value >= 100) {
          self.dialog = false;

          clearInterval(self.interval)
          self.interval = null;
        }
      }, 2000)
       */
    },

    async createStudentDocument() {
      this.form.department_enrollment_id = this.enrolledStudent.id;

      ApiV2.post(`diplomas`, this.form)
          .then(async () => {
            serverBus.$emit("show-snackbar", true);
            await this.startBuffer();
            this.closeDialog();
            this.getStudentDiplomas();
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });

      // TODO Privremeno sklonjeno da ne kreira ucenicke knjizice na polugodistu
      if (this.currentSchool?.canton?.id == 5 && !this.department?.are_numerical_grades ) {
        if(this.booklets.filter(b => b.semester == this.form.semester).length == 0){
          this.createStudentBooklet(this.form)
        }else{
          this.updateStudentBooklet(this.booklets.filter(b => b.semester == this.form.semester)[0].id)
        }
      }

    },

    createOfficialDocument(diploma) {
      let apiUrl = `${diploma.type == 2 ? 'student_booklets' : 'diplomas'}/${this.editIndex}/official`;
      ApiV2.post(apiUrl, {
        official: 1,
      })
          .then(() => {
            this.$store.dispatch("setEnrolledStudent", {
              departmentId: this.$route.params.odjeljenje_id,
              studentId: this.$route.params.ucenik_id,
            });

            serverBus.$emit("show-snackbar", true);
            this.lockDialog = false;
            this.getStudentDiplomas();
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    sendDemand(diploma) {
      const body = {
        demandable_type: `${diploma.type == 2 ? 'StudentBooklet' : 'Diploma'}`,
        demandable_id: this.editIndex,
        reason: this.demandReason,
        school_id: this.currentSchool.id,
        column_name: "official",
      };

      ApiV2.post("demands", body)
          .then(() => {
            this.closeDemandDialog();
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    deleteStudentDocument(diploma) {
      let apiUrl = `${diploma.type == 2 ? 'student_booklets' : 'diplomas'}/${this.editIndex}`;
      ApiV2.delete(apiUrl)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.deleteDialog = false;
            this.getStudentDiplomas();
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    updateStudentDocument() {
      ApiV2.put(`diplomas/${this.editIndex}`, this.form)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.closeDialog();
            this.getStudentDiplomas();
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });

      // if (this.currentSchool?.canton?.id == 5 && !this.department?.are_numerical_grades ) {
      //   if(this.booklets.filter(b => b.semester == this.form.semester).length == 0){
      //     this.createStudentBooklet(this.form)
      //   }else{
      //     this.updateStudentBooklet(this.booklets.filter(b => b.semester == this.form.semester)[0].id)
      //   }
      // }

    },

    createStudentBooklet(form){
      ApiV2.post(`student_booklets`, form)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.closeDialog();
            this.getStudentDiplomas();
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });
    },

    updateStudentBooklet(id){
      ApiV2.put(`student_booklets/${id}`)
          .then(() => {
            serverBus.$emit("show-snackbar", true);
            this.closeDialog();
            this.getStudentDiplomas();
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    saveItem() {
      if (this.editIndex > -1) {
        this.updateStudentDocument();
      } else {
        this.createStudentDocument();
      }
    },
    preFillData() {
      this.items.forEach((item) => {
        switch (item.tag) {
          case "input":
            if (item.title == "Matični broj učenika") {
              this.$refs[item.name][0].internalValue = "1";
              break;
            }
            if (item.type == "number") {
              this.$refs[item.name][0].internalValue = 1;
            }
            if (item.type == "string") {
              this.form[item.name] = "I";
            }
            break;
          case "select":
            if (item.title == "Polugodište") {
              break;
            }
            this.form[item.name] = item.source[0].value;

            break;
          case "textarea":
            this.form[item.name] = "Lorem ipsum dorum, et ani.....";
            break;
          default:
            this.form[item.name] = "";
        }
      });
    },
  },
};
</script>
